import { ReactNode } from "react";

import { get } from "lodash";
import { FormattedMessage } from "react-intl";

import ProgressBar from "../elements-progressbar/ProgressBar";

type DraftSpacePanelProps = {
  _id: string;
  title: string | ReactNode;
  cancellation_policy?: { name?: string };
  completion_percentage?: number;
  toggleModal: (modalId: string, modalData?: Record<string, unknown>) => void;
};

const DraftSpacePanel = ({
  _id = "",
  title = "",
  cancellation_policy = {},
  completion_percentage = 0,
  toggleModal,
}: DraftSpacePanelProps) => {
  const cancellationPolicy = get(cancellation_policy, "name", "");
  return (
    <div className="mylistings-draftspace flex middle space-between space-panel">
      <div className="mylistings-draftspace-title">
        <div className="listing-title ellipsis heavy">{title}</div>
        {cancellationPolicy && (
          <div className="margin-md-top">
            <FormattedMessage
              id="hosting.draft_space_panel.cancellation_policy_text"
              defaultMessage="Cancellation Policy: {policy}"
              values={{ policy: <b>{cancellationPolicy}</b> }}
            />
          </div>
        )}
      </div>
      <div className="flex middle end right-col">
        <div className="mylistings-draftspace-progressbar flex-basis-100">
          <ProgressBar width={completion_percentage.toString()} />
        </div>
        <div className="mylistings-draftspace-btns">
          <div className="flex middle">
            <div className="flex-grow-1">
              <a
                href={`/your-space/${_id}`}
                className="btn btn-primary btn-block"
              >
                <FormattedMessage
                  id="hosting.draft_space_panel.remove_link_text"
                  defaultMessage="Resume"
                />
              </a>
            </div>
            <div className="margin-md-left">
              <button
                onClick={() =>
                  toggleModal("DeleteSpaceModal", { spaceId: _id })
                }
                className="btn remove-click-styling delete-button"
              >
                <img
                  src="/web-hosting/assets/images/trash.svg?v=rb"
                  alt="delete"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DraftSpacePanel;
